export default "__VITE_ASSET__9dNDDEki__"